import React from 'react';
import FilterSelect from './FilterSelect';

export default React.forwardRef((props, ref) => (
  <FilterSelect innerRef={ref} {...props} />
));



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/FilterSelect/index.js